<div>

  <!-- Search Box for Filtering -->
  <input
    matInput
    placeholder="Search..."
    (keyup)="applyFilter($event)"
    style="margin-bottom: 10px; width: 300px;"
    />

    <!-- Column Toggle Controls -->
    <div class="column-display">
      @for (col of allColumns; track col) {
        <label style="margin-right: 10px;">
          <input
            type="checkbox"
            [checked]="displayedColumns.includes(col)"
            (change)="toggleColumn(col)"
            />
            <span>{{ col }}</span>
          </label>
        }
      </div>

      <!-- Draggable Columns -->
      <div cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" class="column-drag">
        @for (column of displayedColumns; track column; let i = $index) {
          <div cdkDrag>
            <span class="drag-handle">☰</span> {{ column }}
          </div>
        }
      </div>

      <!-- Table -->
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z0" matSort>

        <!-- Dynamic Column Definitions -->
        @for (column of displayedColumns; track column) {
          <ng-container [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column }}</th>
            <td mat-cell *matCellDef="let element; let i = index"
              [ngClass]="{'highlight-row': editingCell?.rowIndex === i, 'highlight-cell': editingCell?.rowIndex === i && editingCell?.column === column}"
              (click)="startEditing(i, column)"
              >
              <!--
              <input matInput [(ngModel)]="element[column]" (blur)="stopEditing()" style="width: 100%;" />
              {{element[column]}} {{getType(element)}} -->
              <!-- Dropdown for Enum Columns -->
              @if (enumOptions[column]) {
                <mat-form-field>
                  <mat-select [(ngModel)]="element[column]" (selectionChange)="stopEditing()">
                    @for (option of enumOptions[column]; track option) {
                      <mat-option [value]="option.key">
                        {{ option.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              <!-- Default Input for Other Fields -->
              @if (!enumOptions[column]) {
                <input
                  matInput
                  [(ngModel)]="element[column]"
                  (blur)="stopEditing()"
                  style="width: 100%;"
                  />
              }
              @if (column === 'actions') {
                <button mat-icon-button color="primary" (click)="sendUpdatedItem(element)">
                  <mat-icon>save</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="sendDeletedItem(element)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </td>
          </ng-container>
        }

        <!-- Header Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <!-- Data Rows -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <!-- Pagination -->
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>

